import {
  ITEM_DISCOUNT_TYPE,
  SHIPMENT_DISCOUNT_TYPE
} from 'domains/voucher/constants/voucher-constants'
import * as Yup from 'yup'

const voucherSchema = Yup.object().shape({

  name        : Yup.string().required('Required'),
  description : Yup.string().required('Required'),
  terms       : Yup.string().required('Required'),
  category    : Yup.string().required('required'),

  start_date : Yup.string(),
  end_date   : Yup.string(),

  is_hour_limit   : Yup.boolean().required('Required'),
  device          : Yup.string().required('Required'),
  hour_limit_from : Yup.string()
    .when('is_hour_limit', {
      is   : true,
      then : Yup.string().required('Required')
    }),
  hour_limit_to: Yup.string()
    .when('is_hour_limit', {
      is   : true,
      then : Yup.string().required('Required')
    }),

  is_day_limit : Yup.boolean().required('Required'),
  day_limit    : Yup.string()
    .when('is_day_limit', {
      is   : true,
      then : Yup.string().required('Required')
    }),

  // item_discount_...
  is_item_discount_active: Yup.boolean().required('Required'),

  item_discount_type: Yup.string().required('Required'),

  item_discount_absolute: Yup.number()
    .when([ 'is_item_discount_active', 'item_discount_type' ], {
      is: (isActive, discountType) => (
        isActive && discountType === ITEM_DISCOUNT_TYPE.ABSOLUTE
      ),
      then: Yup.number()
        .positive('Must be more than 0 since you selected Discount Type: Absolute')
        .required('Required'),
      otherwise: Yup.number()
    }),

  item_discount_percentage: Yup.number().when('item_discount_type', {
    is   : (value) => value === ITEM_DISCOUNT_TYPE.PERCENTAGE,
    then : Yup.number()
      .positive('Must be more than 0 since you selected Discount Type: Percentage')
      .max(100, 'Cannot be more than 100')
      .required('Required'),
    otherwise: Yup.number()
  }),

  item_discount_percentage_max: Yup.number().when('item_discount_type', {
    is   : (value) => value === ITEM_DISCOUNT_TYPE.PERCENTAGE,
    then : Yup.number()
      .positive('Must be more than 0 since you selected Discount Type: Percentage')
      .required('Required'),
    otherwise: Yup.number()
  }),

  // shiment_discount_...
  is_shipment_discount_active: Yup.boolean().required('Required'),

  shipment_discount_type: Yup.string().required('Required'),

  shipment_discount_absolute: Yup.number()
    .when([ 'is_shipment_discount_active', 'shipment_discount_type' ], {
      is: (isActive, discountType) => (
        isActive && discountType === SHIPMENT_DISCOUNT_TYPE.ABSOLUTE
      ),
      then: Yup.number()
        .positive('Must be more than 0 since you selected Discount Type: Absolute')
        .required('Required'),
      otherwise: Yup.number()
    }),

  shipment_discount_percentage: Yup.number().when('shipment_discount_type', {
    is   : (value) => value === SHIPMENT_DISCOUNT_TYPE.PERCENTAGE,
    then : Yup.number()
      .positive('Must be more than 0 since you selected Discount Type: Percentage')
      .max(100, 'Cannot be more than 100')
      .required('Required'),
    otherwise: Yup.number()
  }),

  shipment_discount_percentage_max: Yup.number().when('shipment_discount_type', {
    is   : (value) => value === SHIPMENT_DISCOUNT_TYPE.PERCENTAGE,
    then : Yup.number()
      .positive('Must be more than 0 since you selected Discount Type: Percentage')
      .required('Required'),
    otherwise: Yup.number()
  }),

  product_rules: Yup.array().of(
    Yup.object().shape({
      code     : Yup.string().required('Required'),
      operator : Yup.string().required('Required'),
      value    : Yup.mixed().required('Required')
    })
  ),

  cart_rules: Yup.array().of(
    Yup.object().shape({
      code     : Yup.string().required('Required'),
      operator : Yup.string().required('Required'),
      value    : Yup.mixed().required('Required')
    })
  ),

  vouchers_attributes: Yup.array().of(
    Yup.object().shape({
      id       : Yup.number(),
      code     : Yup.string().required('Required'),
      _destroy : Yup.boolean()
    })
  )
})

export default voucherSchema
